import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {ProductTransfer} from '../model/Entities/ProductTransfer';

@Injectable()
export class ProductTransferService extends ApiService<ProductTransfer> {

    protected apiUrl = 'api/product-transfers';  // URL to web api

    protected getObjectType(): any {
        return ProductTransfer;
    }
}



// WEBPACK FOOTER //
// /app/src/services/product-transfer.service.ts